/**
 * Audio utility that handles Chrome's autoplay policy.
 *
 * Chrome blocks audio.play() unless there's been prior user interaction.
 * This utility "unlocks" audio by playing a brief silent moment on first
 * user interaction (e.g., when sending a message).
 */

class AudioManager {
  private unlocked = false
  private completionAudio: HTMLAudioElement | null = null

  constructor() {
    if (typeof window !== 'undefined') {
      this.completionAudio = new Audio('/sounds/completion.mp3')
      this.completionAudio.preload = 'auto'
    }
  }

  /**
   * Call this on any user interaction to unlock audio playback.
   * Safe to call multiple times - only unlocks once.
   */
  unlock(): void {
    if (this.unlocked || !this.completionAudio) return

    // Play and immediately pause to unlock the audio context
    this.completionAudio.volume = 0
    this.completionAudio.play()
      .then(() => {
        this.completionAudio!.pause()
        this.completionAudio!.currentTime = 0
        this.completionAudio!.volume = 1
        this.unlocked = true
      })
      .catch(() => {
        // Still blocked - will try again on next interaction
      })
  }

  /**
   * Play the completion sound.
   */
  playCompletionSound(): void {
    if (!this.completionAudio) return

    this.completionAudio.currentTime = 0
    this.completionAudio.play().catch(err => {
      console.warn('Could not play completion sound:', err)
    })
  }
}

export const audioManager = new AudioManager()
